import { IDataSet } from '../Track';
import { allTrackingEvents } from '../TrackingEvent';

export class EventDataSet<T> implements IDataSet {
    public eventName: allTrackingEvents = undefined;
    public userID: string = undefined;
    public eventTimestamp: string = undefined;
    public sessionID: string = undefined;
    public eventParams: T;
}
